import { render, staticRenderFns } from "./Folha.vue?vue&type=template&id=6a0f7534&scoped=true"
import script from "./Folha.vue?vue&type=script&lang=js"
export * from "./Folha.vue?vue&type=script&lang=js"
import style0 from "./Folha.vue?vue&type=style&index=0&id=6a0f7534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0f7534",
  null
  
)

export default component.exports